import React from "react";

/**
 * Lightweight inline bold renderer for copy strings.
 *
 * Supported markers:
 * - **bold**
 * - [[bold]] (legacy; kept for backwards compatibility)
 *
 * Notes:
 * - No nesting, no other markdown features, no HTML parsing.
 * - If no markers are present, returns the original string for minimal overhead.
 */
export function renderInlineBold(text) {
  if (typeof text !== "string" || text.length === 0) return text;

  // Match either **...** or [[...]] (non-greedy).
  const re = /(\*\*(.+?)\*\*|\[\[(.+?)\]\])/g;
  let match;
  let lastIndex = 0;
  const out = [];
  let key = 0;

  while ((match = re.exec(text)) !== null) {
    const start = match.index;
    const end = re.lastIndex;

    if (start > lastIndex) out.push(text.slice(lastIndex, start));

    const boldInner = match[2] ?? match[3] ?? "";
    out.push(<strong key={`b-${key++}`}>{boldInner}</strong>);

    lastIndex = end;
  }

  if (out.length === 0) return text;
  if (lastIndex < text.length) out.push(text.slice(lastIndex));

  return <>{out}</>;
}


